export default {

    topic: state => state.topic,
    isCategoryTopic: state => state.isCategoryTopic,
    topicsModel: state => state.topicsModel,

    subtopics: state => state.subtopics,

    item: state => state.item,
    clickedReferences: state => state.clickedReferences,
    itemContent: state => state.itemContent,
    topicsNews: state => state.topicsNews,

};